import dynamic from 'next/dynamic';

import { ContentTilesBlockProps } from '../../../components/blocks/ContentTilesBlock';
import { ContentBlockRenderer } from '../../../types/Block';
import { Transformer } from '../../../types/Transformer';
import { ContentTilesSectionContent } from './types';
import { validateNumberOfTiles } from './validation';

/* istanbul ignore next */
export const renderer: ContentBlockRenderer<ContentTilesBlockProps> =
  dynamic<ContentTilesBlockProps>(() =>
    import('src/components/blocks/ContentTilesBlock').then((mod) => mod.ContentTilesBlock),
  );

export const transformer: Transformer<ContentTilesSectionContent, ContentTilesBlockProps> = ({
  _metadata,
  items,
  tracking_title,
}) => ({
  uid: _metadata.uid,
  props: {
    tiles: items.map(({ title, url, image, featured_product_code, tile_background_color }) => ({
      title,
      url,
      imageSrc: image.url,
      ...(tile_background_color.custom_background_color && {
        backgroundColor: tile_background_color.background_color,
      }),
      ...(featured_product_code ? { featuredProductCode: featured_product_code } : {}),
    })),
    trackingTitle: tracking_title,
  },
  errors: validateNumberOfTiles(items.length),
});
